var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74999 3.75L8.74999 1.25M8.74999 1.25H6.24999M8.74999 1.25L5 5M4.16667 1.25H3.25C2.54993 1.25 2.1999 1.25 1.93251 1.38624C1.69731 1.50608 1.50608 1.69731 1.38624 1.93251C1.25 2.1999 1.25 2.54993 1.25 3.25V6.75C1.25 7.45007 1.25 7.8001 1.38624 8.06749C1.50608 8.30269 1.69731 8.49392 1.93251 8.61376C2.1999 8.75 2.54993 8.75 3.25 8.75H6.75C7.45007 8.75 7.8001 8.75 8.06749 8.61376C8.30269 8.49392 8.49392 8.30269 8.61376 8.06749C8.75 7.8001 8.75 7.45007 8.75 6.75V5.83333",
    stroke: "#218BFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExternal);
export default __webpack_public_path__ + "static/media/link-external.668f4625fcf9c6ca75958e8fc1835271.svg";
export { ForwardRef as ReactComponent };